'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function CertificationsPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-6 xxs:py-3 px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-gradient-to-b from-blue-50 to-white'
        : 'bg-gradient-to-b from-gray-900 to-gray-800'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link href="/guide" className={`hover:underline mb-3 xxs:mb-2 inline-block text-sm xxs:text-xs ${
          theme === 'light' ? 'text-blue-600' : 'text-blue-400'
        }`}>
          ← 입문 가이드 목록
        </Link>

        <article className={`rounded-lg shadow-xl p-6 xxs:p-3 ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <h1 className={`text-2xl xxs:text-lg font-bold mb-4 xxs:mb-3 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>프리다이빙 자격증 종류</h1>

          <div className="max-w-none">
            {/* AIDA */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>AIDA 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>세계에서 가장 오래된 프리다이빙 교육 단체 (1992년 설립)</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 1 (입문)</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 10m<br />
                  • 강습 기간: 1-2일<br />
                  • 추천 대상: 프리다이빙 입문자
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 2 (초급)</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 16m<br />
                  • 강습 기간: 2-3일<br />
                  • 추천 대상: 기본기를 다지고 싶은 분
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 3 (중급)</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 24-30m<br />
                  • 강습 기간: 3-4일<br />
                  • 추천 대상: 본격적인 프리다이버
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 4 (상급)</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 32-40m<br />
                  • 강습 기간: 4-5일<br />
                  • 추천 대상: 고급 기술 습득 희망자
                </p>
              </div>
            </div>

            {/* PADI */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>PADI 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>세계 최대 스쿠버/프리다이빙 교육 단체</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-green-50' : 'bg-green-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>PADI Basic Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 12m<br />
                  • 강습 기간: 1일<br />
                  • 특징: 가장 빠르게 시작 가능
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-green-50' : 'bg-green-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>PADI Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 16m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: AIDA 2와 유사한 레벨
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-green-50' : 'bg-green-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>PADI Advanced Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 24m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: 중급 레벨, 다양한 기술 학습
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-green-50' : 'bg-green-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>PADI Master Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 40m<br />
                  • 강습 기간: 3-4일<br />
                  • 특징: 최상위 레벨
                </p>
              </div>
            </div>

            {/* SSI */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>SSI 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>Scuba Schools International - 디지털 교육 시스템이 강점</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-orange-50' : 'bg-orange-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SSI Basic Freediving</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 5m<br />
                  • 강습 기간: 1일<br />
                  • 특징: 수영장에서만 진행
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-orange-50' : 'bg-orange-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SSI Level 1 Freediving</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 20m<br />
                  • 강습 기간: 2일<br />
                  • 특징: 오픈워터 다이빙 포함
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-orange-50' : 'bg-orange-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SSI Level 2 Freediving</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 30m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: 고급 호흡법 및 압력 평형
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-orange-50' : 'bg-orange-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SSI Level 3 Freediving</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 40m<br />
                  • 강습 기간: 3-4일<br />
                  • 특징: 전문 프리다이버 레벨
                </p>
              </div>
            </div>

            {/* CMAS */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>CMAS 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>World Confederation of Underwater Activities - 유럽에서 인지도 높음</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-purple-50' : 'bg-purple-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>CMAS 1 Star Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 15m<br />
                  • 강습 기간: 2일<br />
                  • 특징: 입문 레벨
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-purple-50' : 'bg-purple-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>CMAS 2 Star Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 25m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: 중급 레벨
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-purple-50' : 'bg-purple-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>CMAS 3 Star Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 35m<br />
                  • 강습 기간: 3-4일<br />
                  • 특징: 고급 레벨
                </p>
              </div>
            </div>

            {/* NAUI */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>NAUI 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>National Association of Underwater Instructors - 미국 최초 다이빙 교육 단체</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>NAUI Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 15m<br />
                  • 강습 기간: 2일<br />
                  • 특징: 기초 프리다이빙 교육
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>NAUI Advanced Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 30m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: 심화 과정
                </p>
              </div>
            </div>

            {/* SDI/TDI */}
            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>SDI 자격증</h2>
            <p className={`text-xs xxs:text-[10px] mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>Scuba Diving International - 실용적인 교육 방식</p>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-rose-50' : 'bg-rose-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SDI Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 18m<br />
                  • 강습 기간: 2일<br />
                  • 특징: 기초 프리다이빙
                </p>
              </div>
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-rose-50' : 'bg-rose-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>SDI Advanced Freediver</h3>
                <p className={`text-xs xxs:text-[10px] mt-2 xxs:mt-1.5 ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 최대 수심: 30m<br />
                  • 강습 기간: 2-3일<br />
                  • 특징: 중급 레벨
                </p>
              </div>
            </div>

            {/* 자격증 비교 */}
            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-gray-100' : 'bg-gray-700/50'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-3 xxs:mb-2 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>🔄 협회별 자격증 비교</h3>
              <div className="overflow-x-auto">
                <table className={`w-full text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  <thead>
                    <tr className={theme === 'light' ? 'bg-gray-200' : 'bg-gray-600'}>
                      <th className="p-2 text-left">레벨</th>
                      <th className="p-2 text-left">AIDA</th>
                      <th className="p-2 text-left">PADI</th>
                      <th className="p-2 text-left">SSI</th>
                      <th className="p-2 text-left">CMAS</th>
                      <th className="p-2 text-left">NAUI</th>
                      <th className="p-2 text-left">SDI</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={theme === 'light' ? 'border-b border-gray-200' : 'border-b border-gray-600'}>
                      <td className="p-2">입문</td>
                      <td className="p-2">AIDA 1</td>
                      <td className="p-2">Basic</td>
                      <td className="p-2">Basic</td>
                      <td className="p-2">1 Star</td>
                      <td className="p-2">Freediver</td>
                      <td className="p-2">Freediver</td>
                    </tr>
                    <tr className={theme === 'light' ? 'border-b border-gray-200' : 'border-b border-gray-600'}>
                      <td className="p-2">초급</td>
                      <td className="p-2">AIDA 2</td>
                      <td className="p-2">Freediver</td>
                      <td className="p-2">Level 1</td>
                      <td className="p-2">2 Star</td>
                      <td className="p-2">Advanced</td>
                      <td className="p-2">Advanced</td>
                    </tr>
                    <tr className={theme === 'light' ? 'border-b border-gray-200' : 'border-b border-gray-600'}>
                      <td className="p-2">중급</td>
                      <td className="p-2">AIDA 3</td>
                      <td className="p-2">Advanced</td>
                      <td className="p-2">Level 2</td>
                      <td className="p-2">3 Star</td>
                      <td className="p-2">-</td>
                      <td className="p-2">-</td>
                    </tr>
                    <tr>
                      <td className="p-2">상급</td>
                      <td className="p-2">AIDA 4</td>
                      <td className="p-2">Master</td>
                      <td className="p-2">Level 3</td>
                      <td className="p-2">-</td>
                      <td className="p-2">-</td>
                      <td className="p-2">-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-yellow-50' : 'bg-yellow-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>💡 자격증 선택 팁</h3>
              <ul className={`text-xs xxs:text-[10px] space-y-1.5 xxs:space-y-1 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                <li>• 처음 시작한다면 AIDA 2 또는 PADI Freediver 추천</li>
                <li>• 모든 협회 자격증은 전 세계적으로 인정됨</li>
                <li>• 가까운 센터에서 배울 수 있는 협회 선택이 현실적</li>
                <li>• 자격증보다 중요한 것은 안전한 연습과 경험</li>
                <li>• 협회마다 교육 스타일이 다르니 체험 후 결정 추천</li>
              </ul>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
